import "./index.scss"

const Break = (props) => {
  const { label, size, custom_styles } = props
  return (
    <div className={size}>
      <div className={custom_styles ? custom_styles : `breacker`}>
        {label}
      </div>
    </div>
  )
}

export default Break